import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex fill-current" }
const _hoisted_2 = { class: "text-sm" }

import { computed } from 'vue'

interface Props {
  /** Whether to display success status */
  success?: boolean
  /** Whether to display danger status */
  danger?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseAlert'
},
  __name: 'BaseAlert',
  props: {
    success: { type: Boolean },
    danger: { type: Boolean }
  },
  setup(__props: any) {





const status = computed(() => {
  if (__props.danger) {
    return 'danger'
  }
  if (__props.success) {
    return 'success'
  }
  return 'primary'
})

const statusIcon = computed(
  () =>
    ({
      danger: '$alert-outline',
      success: '$check',
      primary: '$information-outline'
    })[status.value]
)

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-start gap-x-2 rounded-sm border-y-2 border-r-2 border-l-8 p-2 md:p-4", `border-${status.value} bg-${status.value}-light`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_VIcon, {
        icon: statusIcon.value,
        "aria-label": status.value,
        size: "1.25rem",
        class: _normalizeClass(`text-${status.value}`)
      }, null, 8, ["icon", "aria-label", "class"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})